import { Fragment, useRef, useState, useEffect } from "react";
import { Dialog, Transition, Switch, Listbox } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Toaster, ToastIcon, toast, resolveValue } from "react-hot-toast";
import { useDropdown } from "../store/dropdown-context";
import { updateContact } from "../api/zoho";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";

import axios from "../axios/index";
const TailwindToaster = () => {
  return (
    <Toaster>
      {(t) => (
        <Transition
          appear
          show={t.visible}
          className="transform p-4 flex bg-white rounded shadow-lg"
          enter="transition-all duration-150"
          enterFrom="opacity-0 scale-50"
          enterTo="opacity-100 scale-100"
          leave="transition-all duration-150"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-75"
        >
          <ToastIcon toast={t} />
          <p className="px-2">{resolveValue(t.message)}</p>
        </Transition>
      )}
    </Toaster>
  );
};
let citys = [
  { id: 2, name: "مصراتة" },
  { id: 3, name: "بنغازي" },
];
let suburbs = [
  { id: 1, name: "11يونيو" },
  { id: 2, name: "الحي الاسلامي" },
  { id: 3, name: "السبعة" },
];

const SubmitModaSuburb = ({
  setOpenCustomer,
  openCustomer,
  //   city,
  //   suburb,
  phoneNumber,
  //   clientName,
  user,
}) => {
  const cancelButtonRef = useRef(null);

  const [xx, setxx] = useState("");
  const { getCitys, citysContext } = useDropdown();
  const [selectedSuburb, setSelectedSuburb] = useState();
  const [selectedCity, setSelectedCity] = useState();
  const [loadding, setLoadding] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);

  const schema = yup.object().shape({
    clientName: yup.string().nullable(),
    phone: yup.string().required(),
    city: yup.string(),
    suburb: yup.string(),
    zohoId: yup.string(),
  });
  const onSubmit = (data, e) => {
    setDisableSubmit(true);
    e.preventDefault();

    setValue("city", selectedCity?.name, {
      shouldValidate: true,
    });

    setValue("suburb", selectedSuburb?.name, {
      shouldValidate: true,
    });

    setValue("phone", phoneNumber, {
      shouldValidate: false,
    });

    setValue("zohoId", user?.accountCode, {
      shouldValidate: true,
    });

    toast.loading("جاري تعديل البيانات");
    setDisableSubmit(false);
    try {
      updateContact(data)
        .then((data) => {
          toast.dismiss();
          if (data.success === true) {
            setDisableSubmit(false);
            setTimeout(() => {
              toast.success("تم ارسال الاستفسار بنجاح");
            }, 2000);
            setOpenCustomer(false);
            window.location.reload();
          } else {
            setDisableSubmit(false);
            toast.error("حدث خطأ ما");
          }
        })
        .catch((err) => {
          toast.dismiss();
          setDisableSubmit(false);
          toast.error("حدث خطأ ما");
        });
    } catch (error) {
      toast.dismiss();
      setDisableSubmit(false);
      toast.error("حدث خطأ ما");
    }
  };
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });
  useEffect(() => {
    // setLoadding(true);
    // setError('');
    try {
      citys = citysContext;

      console.log(citys, user);
      if (user?.city) {
        console.log(user.city);
        setSelectedCity(citys.find((element) => element?.name === user.city));
      }
      if (user?.stateId) {
        setxx(user?.stateId);
      }
      if (phoneNumber) {
        setValue("phone", phoneNumber, {
          shouldValidate: true,
        });
      }
      if (user?.accountCode) {
        setValue("zohoId", user?.accountCode, {
          shouldValidate: true,
        });
      }

      if (user?.custName) {
        setValue("clientName", user?.custName, {
          shouldValidate: true,
        });
      }
      // setLoadding(false);
    } catch (error) {
      // setError(error.message);
    }
  }, []);
  useEffect(() => {
    console.log(errors);
  }, [errors]);
  useEffect(() => {
    setValue("city", selectedCity?.name, {
      shouldValidate: true,
    });
    setValue("suburb", selectedSuburb?.name, {
      shouldValidate: true,
    });
  }, [selectedCity, selectedSuburb]);

  useEffect(() => {
    if (xx?.length > 0 && selectedCity?.name !== xx) {
      setSelectedSuburb(
        selectedCity?.Suburbs.find((element) => element?.name === xx)
      );
      if (selectedCity?.Suburbs?.length > 0) {
        suburbs = selectedCity?.Suburbs;
      } else {
        suburbs = [selectedCity];
        setSelectedSuburb(suburbs[0]);
      }
    } else {
      if (selectedCity?.Suburbs?.length > 0) {
        suburbs = selectedCity?.Suburbs;
        setSelectedSuburb(suburbs[0]);
      } else {
        suburbs = [selectedCity];
        setSelectedSuburb(suburbs[0]);
      }
    }
  }, [selectedCity, setSelectedCity]);
  return (
    <Transition.Root show={openCustomer} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-10 inset-0 overflow-y-auto font-MyFont"
        initialFocus={cancelButtonRef}
        onClose={setOpenCustomer}
        dir="rtl"
      >
        <div className="flex items-end justify-center min-h-screen px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block  bg-white rounded-lg text-center overflow-hidden shadow-xl transform transition-all  align-middle w-full max-w-3xl ">
              <div className="bg-white  pb-4 sm:pb-4 ">
                <div className="  grid grid-rows-3 grid-flow-col max-h-96 text-center ">
                  <div className=" w-full px-4 pt-4 grid grid-rows-4 ">
                    <div className="flex  justify-end">
                      <button
                        type="button"
                        onClick={() => setOpenCustomer(false)}
                        ref={cancelButtonRef}
                      >
                        <FontAwesomeIcon
                          icon={solid("xmark")}
                          size={"2x"}
                          color={"#808080"}
                        />
                      </button>
                    </div>

                    <Dialog.Title
                      as="h3"
                      className="text-lg leading-6 justify-end font-medium text-title-100 text-center align-middle py-1 px-2 w-full"
                    >
                      <p className="flex w-full justify-center  text-title-100">
                        تعديل بيانات العميل
                      </p>
                    </Dialog.Title>
                  </div>
                  <div className="mt-3 text-right sm:mt-0 sm:ml-4  row-start-2 row-end-4 ">
                    <div className="mt-2 flex flex-row justify-between px-20 pb-6">
                      <div className="px-4 py-2 w-72">
                        <div className="flex ">
                          <div className="w-full  z-30">
                            <Listbox
                              as="div"
                              className="space-y-1"
                              value={selectedCity}
                              onChange={setSelectedCity}
                            >
                              {({ open }) => (
                                <>
                                  <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                                    المدينة
                                  </Listbox.Label>
                                  <div className="relative">
                                    <span className="inline-block w-full rounded-md shadow-sm">
                                      <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                        <span className="block truncate">
                                          {selectedCity?.name}
                                        </span>
                                        <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                                          <svg
                                            className="h-5 w-5 text-gray-400"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            stroke="currentColor"
                                          >
                                            <path
                                              d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                              strokeWidth="1.5"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>
                                        </span>
                                      </Listbox.Button>
                                    </span>

                                    <Transition
                                      show={open}
                                      leave="transition ease-in duration-100"
                                      leaveFrom="opacity-100"
                                      leaveTo="opacity-0"
                                      className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                                    >
                                      <Listbox.Options
                                        static
                                        className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                                      >
                                        {citys?.map((person) => (
                                          <Listbox.Option
                                            key={person?.name}
                                            value={person}
                                          >
                                            {({ selected, active }) => (
                                              <div
                                                className={`${
                                                  active
                                                    ? "text-white bg-blue-600"
                                                    : "text-gray-900"
                                                } cursor-default select-none relative py-2 pl-8 pr-4`}
                                              >
                                                <span
                                                  className={`${
                                                    selected
                                                      ? "font-semibold"
                                                      : "font-normal"
                                                  } block truncate`}
                                                >
                                                  {person?.name}
                                                </span>
                                                {selected && (
                                                  <span
                                                    className={`${
                                                      active
                                                        ? "text-white"
                                                        : "text-blue-600"
                                                    } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                                  >
                                                    <svg
                                                      className="h-5 w-5"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      viewBox="0 0 20 20"
                                                      fill="currentColor"
                                                    >
                                                      <path
                                                        fillRule="evenodd"
                                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                        clipRule="evenodd"
                                                      />
                                                    </svg>
                                                  </span>
                                                )}
                                              </div>
                                            )}
                                          </Listbox.Option>
                                        ))}
                                      </Listbox.Options>
                                    </Transition>
                                  </div>
                                </>
                              )}
                            </Listbox>
                          </div>
                        </div>{" "}
                      </div>
                      <div className="px-4 py-2 w-72">
                        <div className="flex ">
                          <div className="w-full  z-30">
                            <Listbox
                              as="div"
                              className="space-y-1"
                              value={selectedSuburb}
                              onChange={setSelectedSuburb}
                            >
                              {({ open }) => (
                                <>
                                  <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                                    الضاحية
                                  </Listbox.Label>
                                  <div className="relative">
                                    <span className="inline-block w-full rounded-md shadow-sm">
                                      <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                        <span className="block truncate">
                                          {selectedSuburb?.name}
                                        </span>
                                        <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                                          <svg
                                            className="h-5 w-5 text-gray-400"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            stroke="currentColor"
                                          >
                                            <path
                                              d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                              strokeWidth="1.5"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>
                                        </span>
                                      </Listbox.Button>
                                    </span>

                                    <Transition
                                      show={open}
                                      leave="transition ease-in duration-100"
                                      leaveFrom="opacity-100"
                                      leaveTo="opacity-0"
                                      className=" absolute mt-1 w-full rounded-md bg-white shadow-lg"
                                    >
                                      <Listbox.Options
                                        static
                                        className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                                      >
                                        {suburbs?.map((person) => (
                                          <Listbox.Option
                                            key={person?.name}
                                            value={person}
                                          >
                                            {({ selected, active }) => (
                                              <div
                                                className={`${
                                                  active
                                                    ? "text-white bg-blue-600"
                                                    : "text-gray-900"
                                                } cursor-default select-none relative py-2 pl-8 pr-4`}
                                              >
                                                <span
                                                  className={`${
                                                    selected
                                                      ? "font-semibold"
                                                      : "font-normal"
                                                  } block truncate`}
                                                >
                                                  {person?.name}
                                                </span>
                                                {selected && (
                                                  <span
                                                    className={`${
                                                      active
                                                        ? "text-white"
                                                        : "text-blue-600"
                                                    } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                                  >
                                                    <svg
                                                      className="h-5 w-5"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      viewBox="0 0 20 20"
                                                      fill="currentColor"
                                                    >
                                                      <path
                                                        fillRule="evenodd"
                                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                        clipRule="evenodd"
                                                      />
                                                    </svg>
                                                  </span>
                                                )}
                                              </div>
                                            )}
                                          </Listbox.Option>
                                        ))}
                                      </Listbox.Options>
                                    </Transition>
                                  </div>
                                </>
                              )}
                            </Listbox>
                          </div>
                        </div>{" "}
                      </div>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)} className="">
                      <div className="mt-2 flex flex-row justify-between px-20 pb-6">
                        <div className="">
                          <label className="block  leading-5 text-title-100 text-md ">
                            الاسم
                          </label>
                          <input
                            className="w-64 px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            type="text"
                            name="name"
                            {...register("clientName")}
                          />
                          <p className="text-red-500 text-xs italic">
                            {errors.clientName?.message}
                          </p>
                        </div>
                        <div className="">
                          <label className="block  leading-5 text-title-100 text-md ">
                            رقم الهاتف
                          </label>
                          <input
                            className="w-72 px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            type="text"
                            name="phone"
                            {...register("phone")}
                          />
                          <p className="text-red-500 text-xs italic">
                            {errors.phone?.message}
                          </p>
                        </div>
                      </div>
                      <div className=" py-2 sm:px-6 flex  mx-auto justify-center pb-16 pt-4">
                        <button
                          type="submit"
                          className="mt-3 w-full  rounded-md bg-blue-700 shadow-sm px-12 py-2  text-lg text-white hover:bg-blue-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto "
                          ref={cancelButtonRef}
                          disabled={disableSubmit}
                        >
                          تعديل
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
          <TailwindToaster />
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default SubmitModaSuburb;
